import { DateTime } from 'luxon';

export const getOrderTime = () => DateTime.local().toFormat('yyyy-MM-dd HH:mm');
